import React, { Component } from "react";
import { TextInput, SelectInput, EmailInput } from "../../components/BasicForm";
import { PrimaryFormNav } from "../../components/PrimaryFormNav";
import { RadioMultiButton } from "../../components/RadioMultiButton";
import countryList from "../../utils/countryList";
import usStateList from "../../utils/usStateList";

class ApplicantContact extends Component {
  state = {
    heading: "Your Contact Information",
    showProgressBar: true,
    pageId: "applicant-contact"
  };
  componentWillMount() {
    const stepData = this.props.stepData;
    if (!stepData.access) {
      this.props.previousStep(stepData);
    }
    this.props.setHeaderDisplay(
      this.state.heading,
      stepData.displayStep,
      this.state.showProgressBar,
      this.state.pageId,
      stepData.step
    );
  }
  componentDidMount() {
    document.getElementById("root").scrollIntoView();
    window.scrollBy(0, -10);
  }
  handlePrevious = () => {
    const stepData = this.props.stepData;
    this.props.previousStep(stepData);
  };
  handleSubmit = fields => {
    const isErr = this.props.validateStep(fields);
    const stepData = this.props.stepData;

    if (!isErr) {
      this.props.nextStep(stepData);
    } else {
      this.scrollToError();
    }
  };
  scrollToError = () => {
    const fields = this.props.fields;
    let errFields = [];
    Object.keys(fields).map(fieldName => {
      if (fields[fieldName].className === "input-err") {
        errFields.push(fieldName);
      }
      return fieldName;
    });
    const firstErr = document.querySelectorAll(`[name="${errFields[0]}"]`)[0];
    firstErr.scrollIntoView();
  };
  render() {
    const fields = this.props.fields;
    return (
      <div className="col-19">
        <p className="description">All fields are required.</p>
        <form
          className="visitation-form"
          onSubmit={e => {
            this.handleSubmit(Object.keys(fields));
          }}
        >
          <SelectInput
            options={countryList}
            id="applicantCountry"
            name="applicantCountry"
            required={fields.applicantCountry.isRequired}
            className={fields.applicantCountry.className}
            label={fields.applicantCountry.label}
            value={fields.applicantCountry.value || "United States"}
            errMessage={fields.applicantCountry.errMessage}
            onChange={this.props.handleInputChange}
          />
          <TextInput
            label={fields.applicantStreet.label}
            className={fields.applicantStreet.className}
            value={fields.applicantStreet.value}
            name="applicantStreet"
            required={fields.applicantStreet.isRequired}
            maxLength={fields.applicantStreet.maxLength}
            placeholder={fields.applicantStreet.placeholder}
            errMessage={fields.applicantStreet.errMessage}
            onChange={this.props.handleInputChange}
            id="applicantStreet"
          />
          <TextInput
            label={fields.applicantZip.label}
            className={fields.applicantZip.className}
            value={fields.applicantZip.value}
            name="applicantZip"
            required={fields.applicantZip.isRequired}
            placeholder={fields.applicantZip.placeholder}
            errMessage={fields.applicantZip.errMessage}
            onChange={e => {
              this.props.handleZipcodeAutofill(
                e,
                "applicantCity",
                "applicantState",
                "applicantCountry"
              );
            }}
            id="applicantZip"
          />
          <TextInput
            label={fields.applicantCity.label}
            className={fields.applicantCity.className}
            value={fields.applicantCity.value}
            name="applicantCity"
            required={fields.applicantCity.isRequired}
            placeholder={fields.applicantCity.placeholder}
            errMessage={fields.applicantCity.errMessage}
            onChange={this.props.handleInputChange}
            id="applicantCity"
          />
          <SelectInput
            options={usStateList}
            id="applicantState"
            className={fields.applicantState.className}
            name="applicantState"
            required={fields.applicantState.isRequired}
            label={fields.applicantState.label}
            value={fields.applicantState.value}
            errMessage={fields.applicantState.errMessage}
            onChange={this.props.handleInputChange}
          />
          <EmailInput
            label={fields.applicantEmail.label}
            className={fields.applicantEmail.className}
            value={fields.applicantEmail.value}
            name="applicantEmail"
            maxLength={fields.applicantEmail.maxLength}
            required={fields.applicantEmail.isRequired}
            placeholder={fields.applicantEmail.placeholder}
            errMessage={fields.applicantEmail.errMessage}
            onChange={this.props.handleInputChange}
            handleEmailAutocomplete={this.props.handleEmailAutocomplete}
            id="applicantEmail"
          />
          <TextInput
            label={fields.applicantPhone.label}
            type="tel"
            className={fields.applicantPhone.className}
            value={fields.applicantPhone.value}
            required={fields.applicantPhone.isRequired}
            name="applicantPhone"
            maxLength={fields.applicantPhone.maxLength}
            placeholder={fields.applicantPhone.placeholder}
            errMessage={fields.applicantPhone.errMessage}
            onChange={this.props.handleInputChange}
            id="applicantPhone"
          />
          <RadioMultiButton
            legend={fields.applicantPhoneType.legend}
            fieldOpts={fields.applicantPhoneType.options}
            fieldName="applicantPhoneType"
            required={fields.applicantPhoneType.isRequired}
            checkedVal={fields.applicantPhoneType.value}
            errMessage={fields.applicantPhoneType.errMessage}
            handleMultiChange={this.props.handleInputChange}
          />
          <PrimaryFormNav
            prevLabel="Step 6"
            nextLabel="Step 8"
            handlePrevious={this.handlePrevious}
            handleNext={this.handleSubmit}
            options={Object.keys(fields)}
          />
        </form>
      </div>
    );
  }
}

export default ApplicantContact;



// WEBPACK FOOTER //
// ./src/pages/ApplicantContact/ApplicantContact.js